"use client";

import type * as React from "react";

import { cn } from "@/shared/helpers/cn.helper";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement | HTMLButtonElement> {
  children: React.ReactNode;
  as?: "button" | "div" | "article";
  /** Only applies when `as` is `"button"` */
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className, 
  as = "div",
  disabled,
  ...props 
}) => {
  const Component = as;
  const isDisabledButton = as === "button" && disabled;
  
  return (
    <Component
      className={cn(
        "shadow-10 rounded-xl border border-border-2 bg-white",
        as === "button" &&
          !isDisabledButton &&
          "cursor-pointer transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98]",
        className,
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </Component>
  );
};

export { Card };
